import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyQuantityToAllBookingItemsCommand extends BaseCommand {
  CommandName = "CopyQuantityToAllBookingItems";
  Command: { Quantity: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Quantity: value };
  }
}
